module.exports = __webpack_public_path__ + "img/incident-ticket-banner.d60f62db.png";